import React from 'react';
import { useTranslation } from '../../i18n';
import SectionTag from '../common/SectionTag';

const Ressources = () => {
  const { t } = useTranslation();

  const resources = [
    { icon: '💳', key: 'res1' },
    { icon: '🤝', key: 'res2' },
    { icon: '📋', key: 'res3' },
    { icon: '🎁', key: 'res4' },
    { icon: '⚖️', key: 'res5' },
  ];

  return (
    <section className="bg-ofd-blue px-4 md:px-10 py-20 text-white">
      <div className="max-w-7xl mx-auto">
        <SectionTag className="text-ofd-yellow border-ofd-yellow">{t('ressources_tag')}</SectionTag>
        <h2 className="font-playfair text-3xl md:text-4xl font-bold text-white">
          {t('ressources_title')}
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mt-10">
          {resources.map((res, index) => (
            <div
              key={index}
              className="p-6 bg-white/10 rounded border border-white/10 transition-colors hover:bg-white/15"
            >
              <div className="text-2xl mb-2.5">{res.icon}</div>
              <p className="text-white/75 text-sm">{t(res.key)}</p>
            </div>
          ))}
        </div>

        <p className="text-white/50 text-sm mt-7 max-w-3xl">
          {t('res_footer')}
        </p>
      </div>
    </section>
  );
};

export default Ressources;